module.exports = __webpack_public_path__ + "app/components/notices/notices.view.html";